<template>
    <div id="contenedor-nuevo-subtipo-infraestructura">
      <v-form v-model="formularioValido" ref="agregarNuevoSubtipoInfraestructura">
        <v-card>
          <v-card-title class="secondary--text">
            Registrar nuevo subtipo de infraestructura
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrar">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <custom-autocomplete
              v-model="subtipoInfraestructura.idTipoInfraestructura"
              label="Tipo de Infraestructura"
              :items="getTiposInfraestructura"
              item-text="descripcion"
              item-value="id"
              :rules="[mixReglas.requerido]"
              required
            >
            </custom-autocomplete>
            <custom-text-field
              label="Descripción"
              v-model="subtipoInfraestructura.descripcion"
              :rules="[mixReglas.requerido]"
              required
            >
            </custom-text-field>
          </v-card-text>
          <v-divider class="bkground" />
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="cerrar"
              tipo="formCancelar"
              label="Cancelar"
              class="mr-3">
            </custom-button>
            <custom-button
              @click="mixAgregarSubtipoInfraestructura"
              :disabled="!formularioValido  || enviandoFormulario"
              :loading="enviandoFormulario"
              tipo="formAceptar"
              label="Guardar">
            </custom-button>
          </v-card-actions>
        </v-card>
      </v-form>
    </div>
  </template>

<script>
import mixSubtiposInfraestructura from './mixSubtiposInfraestructura';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'AgregarNuevoSubtipoInfraestructura',
  mixins: [mixSubtiposInfraestructura],
  components: {
    CustomTextField,
    CustomAutocomplete,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      subtipoInfraestructura: {
        idTipoInfraestructura: '',
        descripcion: '',
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarformulario();
      this.$emit('cerrar');
    },
    limpiarformulario() {
      this.$refs.agregarNuevoSubtipoInfraestructura.reset();
    },
  },
};
</script>

  <style lang="scss" scoped>

  </style>
